<template>
    <div class="main-apps">
        <template v-for="id in openedIds">
            <div
                v-if="openedAppMap[id].outsideAppTag"
                v-show="currentAppId === id"
                :key="id"
                class="main-apps__iframes"
            >
                <div class="main-apps__external d-flex flex-column align-center justify-center grey66">
                    <span class="mb12">请在新窗口中查看应用</span>
                    <isc-button plain size="small" @click="reopen(openedAppMap[id])">重新打开</isc-button>
                </div>
            </div>
            <div v-else v-show="currentAppId === id" :key="id + '_app_iframe'" class="main-apps__iframes">
                <iframe
                    :id="`app-runner-${id}`"
                    class="main-apps__iframe"
                    height="100%"
                    width="100%"
                    allowfullscreen
                    @load="onLoad(id)"
                ></iframe>
            </div>
        </template>
    </div>
</template>

<script>
import { objectAssign } from '@isyscore/utils/object';
import { eventBus } from '../../../plugins/event-bus';

export default {
    name: 'MainApps',
    data() {
        return {
            /**
             * @type {OpenedAppMap}
             */
            openedAppMap: {}
        };
    },
    computed: {
        currentAppId() {
            return this.$store.state.appManager.currentAppId;
        },
        openedIds() {
            return this.$store.state.appManager.openedAppIds;
        },
        currentApp() {
            return this.openedAppMap[this.currentAppId] || {};
        }
    },
    watch: {
        openedIds: {
            handler() {
                this.openedAppMap = objectAssign(Object.create(null), this.$appManager.openedAppMap);
                this.setIframeSRCs();
            },
            immediate: true
        }
    },
    mounted() {
        eventBus.$on('rewrite-app', (app) => {
            const iframe = document.querySelector(`#app-runner-${this.currentAppId}`);
            iframe.src = app.url;
            // iframe.contentWindow?.location.reload();
        });
    },

    methods: {
        /**
         * 重新打开 外置app
         * @param app {App}
         */
        reopen(app) {
            window.open(app.url);
        },

        onLoad(appId) {
            // 操作 appManager 里边的对象
            const app = this.$appManager.openedAppMap[appId];
            app.loaded = true;
        },

        setIframeSRCs() {
            for (let key in this.openedAppMap) {
                const app = this.openedAppMap[key];
                this.$nextTick(() => {
                    const iframe = document.querySelector(`#app-runner-${key}`);
                    if (iframe && !iframe.src) iframe.src = app.url;
                });
            }
        }
    }
};
</script>

<style scoped lang="scss">
.main-apps {
    width: 100%;
    height: 100%;
    background: #fff;
    overflow: hidden;
    position: absolute;
    z-index: 2;

    &__external {
        width: 100%;
        height: 100%;
    }

    &__iframes {
        width: 100%;
        height: 100%;
        background: #fff;
    }

    &__iframe {
        border: none;
        background: white;
    }
}
</style>
